import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import api from '../services/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { KawaTechLogo } from '../branding/kawatech';

const PasswordRecoveryRequestPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await api.requestPasswordRecovery(email);
      setMessage(response.message || 'Se o e-mail estiver cadastrado, enviaremos as instruções.');
    } catch (error) {
      setMessage('Se o e-mail estiver cadastrado, enviaremos as instruções.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen bg-background lg:grid-cols-[41%_59%]">
      <section className="flex min-h-screen items-center justify-center px-6 py-12">
        <div className="w-full max-w-[430px]">
          <div className="mb-9 text-center">
            <KawaTechLogo className="mx-auto h-9 w-auto" />
            <h1 className="mt-7 text-3xl font-extrabold text-secondary">Recuperar senha</h1>
            <p className="mt-3 text-base text-primary/75">
              Informe seu e-mail para receber as instruções de redefinição.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email" className="font-bold">Email</Label>
              <div className="relative">
                <Mail className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-primary/55" />
                <Input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                  className="h-12 rounded-none border-0 bg-[#edf3ff] pl-12 pr-4 shadow-none focus-visible:ring-1 focus-visible:ring-primary"
                />
              </div>
            </div>

            {message && (
              <div className="bg-primary/10 p-3 text-sm text-primary">
                {message}
              </div>
            )}

            <Button type="submit" className="h-12 w-full bg-primary text-base font-bold" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar instruções'}
            </Button>
          </form>

          <p className="mt-8 text-center text-sm">
            <Link to="/login" className="font-bold text-primary hover:underline">
              Voltar para o login
            </Link>
          </p>
        </div>
      </section>

    <section className="hidden min-h-screen items-center bg-primary px-20 py-16 text-white lg:flex">
      <div className="mx-auto max-w-[620px]">
          <KawaTechLogo variant="negative" className="h-10 w-auto" />
          <h2 className="mt-10 text-5xl font-extrabold leading-tight">
            Segurança para recuperar o acesso sem expor sua conta
          </h2>
          <p className="mt-5 text-lg leading-8">
            O link enviado expira automaticamente e só pode ser usado uma vez.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PasswordRecoveryRequestPage;
